/* eslint-disable import/no-cycle */
import filtersRedux from './build';

const { initialState } = filtersRedux;

export default initialState;
